import { ButtonBase, Grid } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { autorun } from "mobx";
import { observer } from "mobx-react";
import React, { FunctionComponent, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { WidgetContentType } from "../../../models/Dashboard/Widget";
import { DashboardStore } from "../../../stores/Layout/DashboardStore";
import AcxMenu, { AcxMenuItemProps } from "../../UI/Menu/AcxMenu";
import { BaseWidgetDefinition } from "../Definitions/BaseWidgetDefinition";
import theme from "Theme/AppTheme";

interface OwnProps {
    widgetDefinition?: BaseWidgetDefinition;
    disableActions?: boolean;
    dashboardStore?: DashboardStore;
    top?: number;
    right?: number;
}

type Props = OwnProps;

const WidgetMenu: FunctionComponent<Props> = observer((props) => {
    const navigate = useNavigate();

    const [menuItems, setMenuItems] = useState<
        AcxMenuItemProps[] | undefined
    >();
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

    function handleMoreMenuClick(event: React.MouseEvent<HTMLButtonElement>) {
        setAnchorEl(event.currentTarget);
        event.stopPropagation();
        event.preventDefault();
    }

    function handleMoreMenuClose() {
        setAnchorEl(null);
    }

    function handleRemoveClick() {
        props.dashboardStore?.removeWidget(
            props.widgetDefinition?.dashboardItem,
        );
    }

    useEffect(() => {
        const disposer = autorun((r) => {
            const acxMenuItems = props.widgetDefinition?.menuItemsBuilder?.(
                navigate,
                props.dashboardStore,
                () => {
                    setAnchorEl(null);
                },
            );
            setMenuItems(acxMenuItems);
        });
        return () => disposer();
    }, [navigate, props.dashboardStore, props.widgetDefinition]);

    return (
        <>
            {menuItems &&
                !!menuItems.length &&
                !props.dashboardStore?.editMode && (
                    <Grid item style={{ position: "relative" }}>
                        <ButtonBase
                            onClick={handleMoreMenuClick}
                            disabled={
                                props.disableActions ||
                                props.widgetDefinition?.loading
                            }
                            sx={{
                                width: "48px",
                                height: "32px",
                                top: props.top !== undefined ? props.top : -9,
                                right:
                                    props.right !== undefined
                                        ? props.right
                                        : -9,
                                color: theme.palette.black.main,
                            }}
                        >
                            <MoreVertIcon />
                        </ButtonBase>
                    </Grid>
                )}

            {props.dashboardStore?.editMode &&
                props.dashboardStore.canEditDashboard &&
                props.widgetDefinition?.dashboardItem?.contentType !==
                    WidgetContentType.IMMUTABLE && (
                    <ButtonBase
                        onClick={handleRemoveClick}
                        sx={{
                            width: "48px",
                            height: "32px",
                            top: props.top !== undefined ? props.top : -9,
                            right: props.right !== undefined ? props.right : -9,
                            color: "red.main",
                        }}
                    >
                        <CloseIcon />
                    </ButtonBase>
                )}

            <>
                {menuItems && (
                    <AcxMenu
                        menuItems={menuItems}
                        anchorOrigin={{
                            vertical: "top",
                            horizontal: "right",
                        }}
                        transformOrigin={{
                            vertical: "top",
                            horizontal: "left",
                        }}
                        anchorElement={anchorEl}
                        onMenuClose={handleMoreMenuClose}
                    />
                )}
            </>
        </>
    );
});

export default WidgetMenu;
